const index = () => import(/* webpackChunkName: "herb" */ './Index');

export default {
  routes: [
    //项目
    {
      path: '/railage2020/2020/index',
      name: 'railage2020Index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/railage/v2020/router.js